import type {
  EndUserDetailDto,
  EndUserListDto,
  EndUsersListParams,
} from '../types/end-users.types';
import httpClient from '@/core/api/createAxiosHttpClient';
import type { PagedResult } from '@/shared/types/paginated.type';

export const endUsersApi = {
  listEndUsers: async (params: EndUsersListParams = {}) => {
    const queryParams = new URLSearchParams();

    queryParams.append('page', String(params.page ?? 1));
    queryParams.append('pageSize', String(params.pageSize ?? 10));

    if (params.status) queryParams.append('status', params.status);
    if (params.authProvider) queryParams.append('authProvider', params.authProvider);
    if (params.createdFrom) queryParams.append('createdFrom', params.createdFrom);
    if (params.createdTo) queryParams.append('createdTo', params.createdTo);
    if (params.searchTerm) queryParams.append('searchTerm', params.searchTerm);

    return httpClient.get<PagedResult<EndUserListDto>>(`/admin/endusers?${queryParams.toString()}`);
  },

  getEndUserById: async (userId: string) => {
    return httpClient.get<EndUserDetailDto>(`/admin/endusers/${userId}`);
  },
};
